module.exports = __webpack_public_path__ + "static/media/_Dashboard Sidebar Item Master (6).6f6c2365.svg";